import React, { useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Autocomplete, IconButton, TextField, TextFieldProps } from "@mui/material";

import { useQueryHook } from "../../../hooks";
import { useDealActions, useDealIdSelector } from "../../../store";
import { DealBase } from "../../../store/types";
import { MaterialTooltip } from "../../tooltips/MaterialTooltip";

interface SelectDealProps {
  deal: DealBase | null;
  onSelect: (deal: DealBase | null) => void;
  onRemove: () => void;
  title: string;
}

export const SelectDeal: React.FC<SelectDealProps> = ({ deal, onSelect, title, onRemove }: SelectDealProps) => {
  const { getDealsBaseAction } = useDealActions();
  const dealId = useDealIdSelector();
  const { loading, data: deals } = useQueryHook<DealBase[]>(getDealsBaseAction);

  const filteredDeals = useMemo(() => deals?.filter((deal) => deal.id !== dealId), [deals, dealId]); //prevent selecting the same deal as su deal

  return (
    <div className="select-deal">
      <Autocomplete<DealBase>
        sx={{ flexGrow: 1 }}
        loading={loading}
        options={filteredDeals || []}
        value={deal}
        getOptionLabel={(option) => option.title}
        renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: Partial<DealBase>) => (
          <li {...props} key={option.id}>
            {option.title}
          </li>
        )}
        onChange={(_, option) => onSelect(option)}
        renderInput={(params) => (
          <MaterialTooltip title={deal?.title || ""} isShow>
            <TextField {...params} {...commonInputProps} label={title} />
          </MaterialTooltip>
        )}
      />
      <IconButton size="sm" onClick={onRemove}>
        <CloseIcon />
      </IconButton>
      <IconButton
        disabled={!deal}
        size="sm"
        onClick={() => window.open(`/main/deal/${deal!.id}`, "_blank", "noopener,noreferrer")}
      >
        <OpenInNewIcon />
      </IconButton>
    </div>
  );
};

const commonInputProps: Pick<TextFieldProps, "sx" | "size" | "InputLabelProps"> = {
  sx: {
    ".MuiOutlinedInput-root": {
      // width: "310px"
    },
    ".MuiInputBase-input": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  },
  size: "small",
  InputLabelProps: { shrink: true }
};
